import React from 'react';
import InvalidFileModal from '../modals/InvalidFileModal';
import Hero from '../components/Hero';
import CreatingModal from '../modals/CreatingModal';

const Maths = ({setModal})=>{

	const handleFile = e=>{
		const file = e.target.files[0];
		if (!file.name.endsWith(".xlsx")) {
			setModal(<InvalidFileModal variant="type" />);
		} else if (file.size > 1000000) {
			setModal(<InvalidFileModal variant="size" />);
		} else {
			setModal(<CreatingModal file={file} />);
		}
		e.target.value = null;
	}

	return <Hero>
		<div className="hw-sheets">
			<strong>Maths!</strong>
			<div className="upload">
				Upload your completed template to create homework sheets now 
				<button className="upload-button" onClick={()=>document.getElementById("fu").click()}>UPLOAD FILE NOW</button><input style={{display: "none"}} id="fu" type="file" onChange={handleFile} />
			</div>
			<div className="blurb">
				To create your printable homework sheets, just download the template below and follow the instructions on the spreadsheet.  Once you've filled in your
				class details, upload it using the button above to create your PDF printable homework sheets.  There is no need to download the template each time, just 
				save a local copy and update it every time you wish to create a batch of homework sheets.
			</div>
			<div className="download-wrapper">
				<div className="downloads">
					<header>Template files</header>
					<div>Optimised for the pre-2025 curriculum: <a className="template-download" href={`${process.env.PUBLIC_URL}/Jumbletree Learn Maths Homework Sheets - pre 2025 curriculum.xlsx`}>Download</a></div>
					<div>Optimised for the 2025 curriculum:  Coming Soon!  <a href="mailto:info@jumbletree.com?subject=Jumbletree LEARN enquiry&body=Hi, I'm interested in a 2025 curriculum based maths homework sheet on Jumbletree LEARN.  Please let me know when this is available">Express your interest here</a></div>
				</div>
			</div>
		</div>
	</Hero>
}

export default Maths;